var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosMachine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#455079",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-2.5c-.398 0 -.779 .158 -1.061 .439c-.281 .281 -.439 .663 -.439 1.061c0 .398 .158 .779 .439 1.061c.281 .281 .663 .439 1.061 .439h1c.398 0 .779 .158 1.061 .439c.281 .281 .439 .663 .439 1.061c0 .398 -.158 .779 -.439 1.061c-.281 .281 -.663 .439 -1.061 .439h-2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21v1m0 -8v1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21h-7c-.53 0 -1.039 -.211 -1.414 -.586c-.375 -.375 -.586 -.884 -.586 -1.414v-10c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h2m12 3.12v-1.12c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10v-6c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-4c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414v6m8 0h-8m8 0h1m-9 0h-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14v.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17v.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.99v.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17v.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosMachine);
export default __webpack_public_path__ + "static/media/pos-machine.515e89b4f600bd5572c4ea545dba11e6.svg";
export { ForwardRef as ReactComponent };